import { useState } from "react"
import { useAppDispatch, useAppSelector } from "../../../../../lib/redux/hooks"
import Input from "../../../../../ui/molecules/input"
import Button from "../../../../../ui/molecules/button"
import { addIVUpdateStartingEndingVisits, setIVUpdateStartingEndingVisitsByIndex } from "../../../slice"
import { Calendar } from "../../../../../ui/molecules/calendar"

interface Props {
    close: () => void
    visitIndex: number
}

export function IVHoursPopupEdit(props: Props) {
    const dispatch = useAppDispatch()
    const assignmentState = useAppSelector(state => state.assignment)
    const [date, setDate] = useState<Date | undefined>(new Date(assignmentState.inspectionVisitUpdateRequest.startingEndingVisits[props.visitIndex].split('@')[0]))
    const [startHour, setStartHour] = useState<string | undefined>(assignmentState.inspectionVisitUpdateRequest.startingEndingVisits[props.visitIndex].split('@')[1])
    const [endHour, setEndHour] = useState<string | undefined>(assignmentState.inspectionVisitUpdateRequest.startingEndingVisits[props.visitIndex].split('@')[2])

    return (
        <div>
            <div className="bg-brandPrimary-100 pr-5 pl-5 pt-4 pb-5" style={{ borderTopWidth: 1 }}>
                <div className="pb-3" style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                    <div style={{ flex: '0.33' }}>
                        <div className='text-left assignment-text-content'>
                            Orario di Inizio Visita
                        </div>
                        <Calendar 
                            selected={date}
                            onChange={(date) => setDate(date)}
                            />
                    </div>

                    <div style={{ flex: '0.33' }}>
                        <div className='text-left assignment-text-content'>
                            Orario di Inizio Visita
                        </div>
                        <Input
                            value={startHour}
                            onChangeText={(text) => setStartHour(text)}
                            placeholder="Specifica nel formato hh:mm"
                        />
                    </div>

                    <div style={{ flex: '0.33' }}>
                        <div className='text-left assignment-text-content'>
                            Orario di Fine Visita
                        </div>
                        <Input
                            value={endHour}
                            onChangeText={(text) => setEndHour(text)}
                            placeholder="Specifica nel formato hh:mm"
                        />
                    </div>
                </div>
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end', padding: 15, paddingRight: 15 }}>
                <div className="pl-2">
                    <Button
                        size="md"
                        variant="solid"
                        iconPosition="off"
                        label="Salva"
                        color="orange"
                        onClick={() => {
                            dispatch(setIVUpdateStartingEndingVisitsByIndex({ index: props.visitIndex, data: `${date?.toString()}@${startHour}@${endHour}` }))
                            props.close()
                        }}
                    />
                </div>
            </div>
        </div>
    )
}

interface PropsAdd {
    close: () => void
}

export function IVHoursPopupAdd(props: PropsAdd) {
    const dispatch = useAppDispatch()
    const assignmentState = useAppSelector(state => state.assignment)
    const [date, setDate] = useState<Date | undefined>(new Date())
    const [startHour, setStartHour] = useState<string | undefined>('00:00')
    const [endHour, setEndHour] = useState<string | undefined>('00:00')

    return (
        <div>
            <div className="bg-brandPrimary-100 pr-5 pl-5 pt-4 pb-5" style={{ borderTopWidth: 1 }}>
                <div className="pb-3" style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                    <div style={{ flex: '0.33' }}>
                        <div className='text-left assignment-text-content'>
                            Orario di Inizio Visita
                        </div>
                        <Calendar 
                            selected={date}
                            onChange={(date) => setDate(date)}
                            />
                    </div>

                    <div style={{ flex: '0.33' }}>
                        <div className='text-left assignment-text-content'>
                            Orario di Inizio Visita
                        </div>
                        <Input
                            value={startHour}
                            onChangeText={(text) => setStartHour(text)}
                            placeholder="Specifica nel formato hh:mm"
                        />
                    </div>

                    <div style={{ flex: '0.33' }}>
                        <div className='text-left assignment-text-content'>
                            Orario di Fine Visita
                        </div>
                        <Input
                            value={endHour}
                            onChangeText={(text) => setEndHour(text)}
                            placeholder="Specifica nel formato hh:mm"
                        />
                    </div>
                </div>
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end', padding: 15, paddingRight: 15 }}>
                <div className="pl-2">
                    <Button
                        size="md"
                        variant="solid"
                        iconPosition="off"
                        label="Salva"
                        color="orange"
                        onClick={() => {
                            dispatch(addIVUpdateStartingEndingVisits(`${date?.toString()}@${startHour}@${endHour}`))
                            props.close()
                        }}
                    />
                </div>
            </div>
        </div>
    )
}